module.exports = __webpack_public_path__ + "img/94834.92f8c322.svg";